import { schema } from "normalizr";

const EducationSchema = new schema.Entity("educations");
const EducationArraySchema = new schema.Array(EducationSchema);

export { EducationSchema, EducationArraySchema };